/**
 * The product name in one place. The working name is RydRes; a trademark review may rename
 * it before launch, and everything user-facing reads from here.
 */
export const BRAND = {
    name: 'RydRes',
    tagline: 'Your riders, your prices, your records.',
    publicOrigin: 'https://rydres.com',
    appOrigin: 'https://app.rydres.com',
    supportEmail: 'support@rydres.com',
    /** The company behind the name, shown beside it in footers (RydRes is its trading name). */
    operator: 'Smart Coders LLC',
    /** The phone app in the stores; the links work once the app is published there. */
    apps: {
        appStoreId: '6829128954',
        appStore: 'https://apps.apple.com/app/id6829128954',
        googlePlay: 'https://play.google.com/store/apps/details?id=com.rydres.app',
    },
};
//# sourceMappingURL=brand.js.map